var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "mx-n6 mb-0" },
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        [
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-flex align-center font-weight-medium text-truncate name",
                              },
                              [
                                _vm._v(" " + _vm._s(_vm.user.username) + " "),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1 copy-icon",
                                    attrs: { "x-small": "" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.copyToClipboard(
                                          _vm.user.username
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("mdi-content-copy")]
                                ),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "ml-1",
                                    attrs: {
                                      "x-small": "",
                                      color: _vm.user.privateRecording
                                        ? "error"
                                        : "success",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.user.privateRecording
                                          ? "mdi-eye-off"
                                          : "mdi-eye"
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "d-block text-truncate text-caption text--secondary",
                              },
                              [_vm._v(" " + _vm._s(_vm.user.displayName) + " ")]
                            ),
                            !_vm.user.password?.length
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "d-block text-truncate text-caption red--text font-weight-bold",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("sip-password-missing")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("v-spacer", { staticClass: "mt-n4" }),
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2 edit-icon",
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$emit("onEdit", _vm.user)
                                },
                              },
                            },
                            [_vm._v(" mdi-pencil ")]
                          ),
                          _c("v-checkbox", {
                            staticClass: "mr-2 mt-n1",
                            attrs: { "hide-details": "" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                              change: _vm.handleCheckboxChange,
                            },
                            model: {
                              value: _vm.checkboxValue,
                              callback: function ($$v) {
                                _vm.checkboxValue = $$v
                              },
                              expression: "checkboxValue",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel-content",
                        [
                          _c("v-divider"),
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-block mt-2 font-weight-regular name",
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("display-name")) + ":"),
                              ]),
                              _vm._v(" " + _vm._s(_vm.user.displayName) + " "),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-flex align-center mt-2 font-weight-regular name",
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("password")) + ":"),
                              ]),
                              _vm._v(" " + _vm._s(_vm.user.password) + " "),
                              _vm.user.password?.length
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "ml-1 copy-icon",
                                      attrs: { "x-small": "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.copyToClipboard(
                                            _vm.user.password
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("mdi-content-copy")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-block mt-2 font-weight-regular name",
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("sip-private-recording")) + ":"
                                ),
                              ]),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "ml-1",
                                  attrs: {
                                    small: "",
                                    color: _vm.user.privateRecording
                                      ? "success"
                                      : "grey",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.user.privateRecording
                                        ? "mdi-check-circle"
                                        : "mdi-close-circle"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-block mt-2 font-weight-regular name",
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t("sip-default-group")) + ":"
                                ),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.user.defaultUserGroupName ||
                                      _vm.$t("none")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "d-block mt-2 font-weight-regular name",
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("user-associated")) + ":"),
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.fullName(_vm.user.name || "")) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "v-row",
                            { staticClass: "d-flex justify-start pl-n6 pt-2" },
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex", attrs: { cols: "2" } },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("groups")) + ":"),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex flex-wrap justify-start",
                                  attrs: { cols: "10" },
                                },
                                _vm._l(_vm.user.groups, function (group) {
                                  return _c(
                                    "v-btn",
                                    {
                                      key: group?.id,
                                      staticClass: "rounded-xl mr-2 mb-2 group",
                                      attrs: { color: "primary", small: "" },
                                    },
                                    [_vm._v(" " + _vm._s(group?.label) + " ")]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }